import { Pipe, PipeTransform } from '@angular/core';
import { StatistikNetomslaFaktura } from './StatistikNetomslaFaktura';

@Pipe({
    name: 'StatistikNetomslaPipe',
    standalone: false
})
export class StatistikNetomslaPipe implements PipeTransform {
    transform(array: StatistikNetomslaFaktura[], property: string): number {
        if (!array || array.length < 1) {
            return 0;
        }

        return array.reduce((total, faktura) => {
            const value = faktura[property];
            return total + value;
        }, 0);
    }
}
